module.exports = (__webpack_require__(18))(2640);